<div class="content-block">
  <article class="article " style="margin-top:1rem">
    <h2>User Home</h2>
    <hr />
    <p>Welcome to the LGS user home page.</p>
    <p>
      You are able to view the sites listed in the drop-down box below. Please select one of the customer sites
      from the list:
    </p>

    <div style="width: 100%;position:relative">
      <app-company-picker  [triggerRefetch]="refetchCompanies" [accountId]="filter.companyId" [disable]="disableCompany" [_placeholder]="'All'"
        (onCompanySet)="onCompanyChange($event)"></app-company-picker>
    </div>
    <div style="text-align: justify;justify-content: start;width: 100%;" *ngIf="!readOnly">


      <p>You are able to create a new customer site by clicking on the link below:</p>

      <button class="btn btn-primary" (click)="createCompany()">Create new customer site</button>
      <p> Inspectors can be added or changed by clicking the link below:</p>
      <button class="btn btn-primary" (click)="navigteToEngineerManagement()">Add/Amend Engineers</button>

      <p> Amend or create users for the web portal below:</p>
      <button class="btn btn-primary" (click)="navigteToUserManagement()">Add/Amend Users</button>
    </div>
    <div style="text-align: justify;justify-content: start;width: 100%;" *ngIf="readOnly">


      <p> Inspectors can be viewed by clicking the link below:</p>
      <button class="btn btn-primary" (click)="navigteToEngineerManagement()">View Engineers</button>

      <p> View users for the web portal below:</p>
      <button class="btn btn-primary" (click)="navigteToUserManagement()">View Users</button>
    </div>
  </article>
</div>


<popup-modal id="popup-company-add">
  <article class="popup-artical">
    <div class="popup-container">
      <div class="popup-header">
        <h2>Add new Company</h2>
      </div>

      <div class="popup-content">
        <app-company-mange [user]="user" [saveTrigger]="companySaveTrigger" (added)="companySave($event)"></app-company-mange>
      </div>

      <div class="popup-footer">
        <div class="btn-container">
          <button class="btn btn-primary" (click)="closeCompanyModal('popup-company-add')">Close</button>
          <button class="btn btn-primary" (click)="triggerCompanySave()">Save</button>

        </div>
      </div>
    </div>
  </article>

</popup-modal>